/* eslint-disable react/react-in-jsx-scope */
import { Content } from '@backstage/core-components';
import {
  createFrontendModule,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';

// Instance-wide (not per-user) admin settings — e.g. the event-driven AI
// readiness dispatch toggle. Content is gated by aiReadinessAdminPermission
// (Cerebro admins / group:default/devex only); non-admins see an "Admins
// only" message rather than the tab being fully hidden.
//
// This is added as an extension to the stock @backstage/plugin-user-settings
// page rather than an override, so the stock General/Auth-providers/Feature-
// flags tabs are used unmodified — only this one tab is Cerebro-specific.
const cerebroGlobalSettingsPage = SubPageBlueprint.make({
  name: 'global-settings',
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: 'global-settings',
    title: 'Global Settings',
    loader: () =>
      import('../../components/settings/CerebroGlobalSettings').then(
        m => (
          <Content>
            <m.CerebroGlobalSettings />
          </Content>
        ),
      ),
  },
});

export const cerebroUserSettingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [cerebroGlobalSettingsPage],
});
